"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 0.5rem;\n  height: 0.5rem;\n  margin: 1rem 0.15rem;\n  background: ", ";\n  border-radius: 9999px;\n  animation: 0.6s bounce infinite alternate;\n\n  &:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n\n  &:nth-child(3) {\n    animation-delay: 0.4s;\n  }\n\n  @keyframes bounce {\n    to {\n      opacity: 0.3;\n      transform: translate3d(0, -0.5rem, 0);\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// import PropTypes from 'prop-types';
var SmallLoader = function SmallLoader() {
  return _react.default.createElement(LoaderWrapper, null, _react.default.createElement(Ball, null), _react.default.createElement(Ball, null), _react.default.createElement(Ball, null));
};

var LoaderWrapper = _styledComponents.default.div(_templateObject());

var Ball = _styledComponents.default.div(_templateObject2(), function (_ref) {
  var theme = _ref.theme;
  return theme.brand.light;
}); // SmallLoader.propTypes = {};


var _default = SmallLoader;
exports.default = _default;